module.exports = __webpack_public_path__ + "img/9.485cb54a.jpg";